import { RouterModule, Routes } from "@angular/router";
import { OrgUserManagementComponent } from "../org-user-management.component";
import { NgModule } from "@angular/core";

export enum OrgUserManagementUrls {
  base = 'org-user-management',
  _orgSettings = 'org-settings',
  _userSettings = 'user-settings',
}

const routes: Routes = [
  {
    path: '',
    component: OrgUserManagementComponent,
    children: [
      {
        path: OrgUserManagementUrls._orgSettings,
        component: OrgUserManagementComponent,
      },
      {
        path: OrgUserManagementUrls._userSettings,
        component: OrgUserManagementComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrgUserMngmntRoutingModule { }
